import { UserRole } from '@lmc/ts-common'
import { useRoleAccess } from 'components/AccessControl'
import useFeatureFlags from 'hooks/useFeatureFlags'
import type { FC } from 'react'
import TeamList from './TeamList'
import TeamListGroups from './TeamListGroups'

export const TeamListGroupsRedirect: FC = () => {
  const flags = useFeatureFlags({
    flagNames: ['group_access_management']
  })?.data

  const hasGroupAdminRolePermission = useRoleAccess(UserRole.groupAdmin)

  const hasGroupManagerRolePermission = useRoleAccess(UserRole.groupManager)

  const groupAccessManagementEnabled = flags?.group_access_management?.enabled

  if (
    groupAccessManagementEnabled &&
    (hasGroupAdminRolePermission || hasGroupManagerRolePermission)
  ) {
    return <TeamListGroups />
  }

  return <TeamList />
}
